export class Category {
    $key: string;
    position: number;
    text: string = null;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/category.ts